import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'

import { MpaNavigationSymbol } from './symbols'
import { MpaNavigation } from './mpaNavigation'

export type { IMpaNavigation } from './types'
export { isSameUrlExceptQuery } from './utils'

export const site: ContainerModuleLoader = (bind) => {
	bind(MpaNavigationSymbol).to(MpaNavigation)
}

export { MpaNavigationSymbol }

// Master page config (for site-assets)
export { mpaNavigationMasterPageConfigEntry } from './configs'
